import { render, staticRenderFns } from "./Продажы по группам1.vue?vue&type=template&id=3028c687&scoped=true"
import script from "./Продажы по группам1.vue?vue&type=script&lang=js"
export * from "./Продажы по группам1.vue?vue&type=script&lang=js"
import style0 from "./Продажы по группам1.vue?vue&type=style&index=0&id=3028c687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028c687",
  null
  
)

export default component.exports